import { createApp } from 'vue';
import PetsSlider from "./components/PetsSlider.vue";
import './scss/main.scss';

const components = {
    'pets-slider': PetsSlider,
};

Object.entries(components).forEach(([name, component]) => {
    const el = document.querySelector(`[data-vue-component="${name}"]`);
    if (el) {
        const props = el.dataset.props ? JSON.parse(el.dataset.props) : {}
        el.removeAttribute('data-props');
        createApp(component, props).mount(el);
    }
})

const counters = document.querySelectorAll(".section-numbers__number span");

counters.forEach((counter) => {
    counter.innerText = "0";
    const updateCounter = () => {
        const target = +counter.getAttribute("data-target");
        const count = +counter.innerText;
        const increment = target / 100;
        if (count < target) {
            counter.innerText = `${Math.ceil(count + increment)}`;
            setTimeout(updateCounter, 1);
        } else counter.innerText = target;
    };
    updateCounter();
});
